"use client";

import { convertWithBrSpan } from "@/lib/helper/converter";
import Marquee from "react-fast-marquee";
import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import hasFadeAnim from "@/lib/animation/hasFadeAnim";
import { useDirection } from "@/context/app.context";

type Props = {
  text: string;
};

const SeoSlider = ({ text }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null!);
  const { direction } = useDirection();

  useGSAP(
    () => {
      hasFadeAnim();
    },
    { scope: containerRef },
  );
  return (
    <div ref={containerRef}>
      <div className="has_fade_anim">
        <div dir="ltr" className=" pt-[30px] xl:pt-[90px] 2xl:pt-[110px]">
          <Marquee
            direction={direction === "rtl" ? "right" : "left"}
            autoFill
            speed={100}
          >
            <div className="ms-3">
              <h2
                className="seo-text-slider font-superclarendon font-light italic text-[40px] md:text-[70px] lg:text-[80px] xl:text-[130px] 2xl:text-[180px] leading-tight"
                dangerouslySetInnerHTML={convertWithBrSpan(text)}
              />
            </div>
          </Marquee>
        </div>
      </div>
    </div>
  );
};

export default SeoSlider;
